export const MESSAGE = {
  MSGTYPE: {
    MODULE_READY: "module_ready",
    MODULE_STARTED: "module_started",
    CREDENTIAL_REQUEST: "credentials_request",
    CREDENTIAL_RESPONSE: "credentials_response",
    CREDENTIAL_MISSING: "credentials_missing",
    CREDENTIAL_CHANGED: "credentials_changed",
    USER_LOGOUT: "user_logout",
    USER_LOGGED_OUT: "user_logged_out",
    NOTIFY_TARGET_DOC: "notify_target_doc",
    INTERACTION: "interaction",
    OPEN_WINDOW: "open_window",
    GOTO_HOME: "goto_home",
    REQUEST_FOCUS: "request_focus",
    DIRTY_STATE: "dirty_state",
    SAVE_STATUS: "save_status",
    BUSY_STATUS: "busy_status",
    OPEN_LINK: "open_link",
    SAVE_DOC_REQUEST: "save_doc_request",
    SAVE_DOC_RESPONSE: "save_doc_response",
    DOC_NAME_REQUEST: "doc_name_request",
    DOC_NAME_RESPONSE: "doc_name_response",
    DOC_NAME_CHANGED: "doc_name_changed",
    SHOW_SHARE_DIALOG: "show_share_dialog",
    OPEN_FROM_DRIVE: "open_from_drive",
    CHOOSEN_FILE_DRIVE: "choosen_file_drive",
    SET_LOADING_STATUS: "set_loading_status",
    GET_INITIAL_STATE: "get_initial_state",
    SET_INITIAL_STATE: "set_initial_state",
    OPEN_MAP_SHOW: "open_map_show",
    SWITCH_TO_EDIT_SHOW: "switch_to_edit_show",
    COPY_DOC: "copy_doc",
    MATH_CONTENT: "math_content",
    MATH_OPEN: "math_open",
    CREATE_MAP_DOC_FILE: "create_doc_file",
    MAP_DOC_FILE_CREATED: "map_doc_file_created",
    OPEN_DOC: "open_doc",
    DOC_OPENED: "doc_opened",
    TOAST_MESSAGE: "toast_message",
    ENABLE_TTS: "tss_enabled",
    PLAY: "play",
    PLAY_RESPONSE: "play_response",
    PRINT: "print",
    CENTER_MAP: "center_map",
    ZOOM: "zoom",
    FIND_IN_DOC: "find_in_doc",
    CONVERT_TO_IMAGE: "convert_to_image",
    SELECTION_CHANGE: "selection_change",
    SPEAK: "speak",
    STOP_SPEAK: "stop_speak",
    TALKING_START: "talking_start",
    TALKING_END: "talking_end",
    TTS_BOUNDARY: "tts_boundary",
    CLOSE: "close",
    PASTE_SELECTION: "paste_selection",
    PASTE_SELECTION_AS_DEEP: "paste_selection_as_deep",
    SEARCH_SELECTION: "search_selection",
    COPY_SELECTION: "copy_selection",
    COPY_RESPONSE: "copy_response",
    LANGUAGE_CHANGED: "language_changed",
    SPEECH_RECOGNITION_TO_MAP: "speech_recognition_to_map",
    SPEECH_RECOGNITION_TO_SHELL: "speech_recognition_to_shell",
    SPEECH_RECOGNITION_TEXT: "speech_recognition_text",
    IMAGE_INSERT: "image_insert",
    REQUEST_CROP_IMAGE: "request_crop_image",
    MODULE_CROP_RECEIVED: "module_crop_message",
    LOCK_DOC: "lock_doc",
    EDIT_IMAGE: "edit_image",
    CROP_PASTE_IMAGE_DIALOG: "crop_paste_image_dialog",
    BEFORE_EXIT: "before_exit",
    NETWORK_ERROR: "network_error",
    DOC_PICKER_REQUEST: "doc_picker_request",
    DOC_PICKER_RESPONSE: "doc_picker_response",
    IMAGE_MAP_REQUEST: "image_map_request",
    IMAGE_MAP_RESPONSE: "image_map_response",
    IMAGE_MAP_INSERT: "image_map_insert",
    REQUEST_LOGIN: "request_login",
    REQUEST_CREDENTIALS_SIMPLE: "request_credentials_simple",
    RESPONSE_CREDENTIALS_SIMPLE: "response:credentials_simple",
    MAP_FRAGMENT_COPIED: "map_fragment_copied",
    IMPORT_DOC_FROM_LOCAL: "import_doc_from_local",
    SET_TAB_TITLE: "set_tab_title",
    ATTACH_NEW_DOC: "attach_new_doc",
    FORCE_CLOSE: "force_close",
    OPEN_SNACKBAR_FROM_MODULE: "open_snackbar_from_module",
    BUY_CREDITS: "buy_credits",
    TL_CONFIG: "TL_CONFIG",
    TL_CREDITS: "TL_CREDITS",
    TL_USE_CREDITS: "TL_USE_CREDITS",
    LOG_TL_USER: "TL_LOG_USER",
    TL_TARIFFS: "TL_TARIFFS",
    TL_TTS: "TL_TTS",
    TL_INTERACTION: "TL_INTERACTION",
    TL_WORKING: "TL_WORKING",
    TL_FROM_MODULE: "TL_FROM_MODULE",
    ON_USER_PREFERENCE_CHANGED: "ON_USER_PREFERENCE_CHANGED",
  }
};


export const MODULE_TYPE = {
  SHELL: "shell",
  ADMIN: "admin",
  EDITOR: "editor",
  MAP: "map",
  PDF: "pdf",
  NOTES: "notes",
  TODOLIST: "todolist",
  LIBRARY: "library",
  PROMPTGEN: "promptgen",
  IMAGEEDITOR: "imageeditor",
  CONFIG: "config",
};
